import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';



import { BrowserModule } from '@angular/platform-browser';



import { ReactiveFormsModule, FormsModule } from '@angular/forms';



import { CommonModule } from '@angular/common';



import { AppRoutingModule } from './app-routing.module';



import { AppComponent } from './app.component';



import { LoginComponent } from './login/login.component';



import { EmployeeComponent } from './employee/employee.component';



import { CustomersComponent } from './customers/customers.component';



import { BrowserAnimationsModule } from '@angular/platform-browser/animations';







import { ApiService } from './services/api.service';

import { PipeInventoryService } from './services/pipe-inventory.service';



import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';



import { StoreDevtoolsModule } from '@ngrx/store-devtools';



import { environment } from '../environments/environment'; 



import { MaterialModule } from './material.module';



import { CustomerDialog } from './dialogs/customer/customer.component';



import { EmployeeDialog } from './dialogs/employee/employee.component';



import { LoginlayoutComponent } from './layouts/loginlayout/loginlayout.component';



import { MainlayoutComponent } from './layouts/mainlayout/mainlayout.component';



import { ImagepreviewComponent } from './dialogs/imagepreview/imagepreview.component';



import { BilldetailsDialog } from './dialogs/billdetails/billdetails.component';



import { MeterdetailsComponent } from './meterdetails/meterdetails.component';



import { QRCodeModule } from 'angular2-qrcode';



import { QrcodeComponent } from './dialogs/qrcode/qrcode.component';



import { CookieService } from 'ngx-cookie-service';



import { AreadetailsComponent } from './areadetails/areadetails.component';



import { UnitrateComponent } from './unitrate/unitrate.component';



import { GoogleMapsModule } from '@angular/google-maps';



import { BillreportsComponent } from './billreports/billreports.component';



import { DuebillsComponent } from './dialogs/duebills/duebills.component';



import { CustomerBillsComponent } from './dialogs/customerbills/customerbills.component';



import { NewbillComponent } from './dialogs/newbill/newbill.component';



import { ExpensesComponent } from './expenses/expenses.component';



import { MatDatepickerModule } from '@angular/material/datepicker';



import { MatPaginatorModule } from '@angular/material/paginator';



import { MatInputModule } from '@angular/material/input';



import { MatNativeDateModule } from '@angular/material/core';



import { AlertDialog } from './dialogs/alerts/alert-dialog.component';



import { MatSlideToggleModule } from '@angular/material/slide-toggle';



import {



  MatDialogModule,



  MAT_DIALOG_DEFAULT_OPTIONS



} from '@angular/material/dialog';



import { ReceiptpreviewComponent } from './dialogs/receiptpreview/receiptpreview.component';



import { SwitchthemeComponent } from './switchtheme/switchtheme.component';



import { ComplaintComponent } from './complaint/complaint.component';



import { AddcomplaintComponent } from './dialogs/addcomplaint/addcomplaint.component';



import { ViewcomplaintsComponent } from './dialogs/viewcomplaints/viewcomplaints.component';



import { AccessControlModule } from './access-control/access-control.module';











import { NgSelectModule } from '@ng-select/ng-select';



import { ControlComponent } from './dialogs/control/control.component';



import { PaymentsComponent } from './dialogs/payments/payments.component';



import { WagesComponent } from './wages/wages.component';



import { WagedetailsComponent } from './wagedetails/wagedetails.component';



import { WageeditComponent } from './wageedit/wageedit.component';



import { WageAuditDialogComponent } from './wage-audit-dialog/wage-audit-dialog.component';



import { EmployeeLocationsComponent } from './employee-locations/employee-locations.component';



import { PayrollRunsComponent } from './payroll-runs/payroll-runs.component';



import { PayrollRunDetailsComponent } from './payroll-run-details/payroll-run-details.component';



import { PayrollItemEditDialogComponent } from './payroll-item-edit-dialog/payroll-item-edit-dialog.component';



import { PayrollProfilesComponent } from './payroll-profiles/payroll-profiles.component';



import { FuiDashboardComponent } from './fui-dashboard/fui-dashboard.component';

import { ComplaintsDashboardFuiComponent } from './complaints-dashboard-fui/complaints-dashboard-fui.component';



import { PayslipsComponent } from './payslips/payslips.component';



import { MonthlyPayrollExpenseComponent } from './monthly-payroll-expense/monthly-payroll-expense.component';



import { EmployeeProfileFuiComponent } from './employee-profile-fui/employee-profile-fui.component';

import { EmployeeFormPrintComponent } from './employee-form-print/employee-form-print.component';



import { HrAttendanceFuiComponent } from './hr-attendance-fui/hr-attendance-fui.component';



import { TranslatePipe } from './shared/translate.pipe';



import { HrPayrollGuideComponent } from './hr-payroll-guide/hr-payroll-guide.component';

import { BillingDashboardComponent } from './billing-dashboard/billing-dashboard.component';

import { BillingCycleGraphComponent } from './billing-cycle-graph/billing-cycle-graph.component';

import { CustomerTransferReportComponent } from './customer-transfer-report/customer-transfer-report.component';

import { AuditLogComponent } from './audit-log/audit-log.component';

import { MeterChangesComponent } from './meter-changes/meter-changes.component';

import { DateChangeComponent } from './date-change/date-change.component';

import { DateChangeBillsDialogComponent } from './date-change/date-change-bills-dialog.component';

import { ViewBillInfoComponent } from './view-bill-info/view-bill-info.component';

import { BankComponent } from './bank/bank.component';

import { AccountUploadDialog } from './dialogs/account-upload/account-upload.component';

import { MerchantUploadDialog } from './dialogs/merchant-upload/merchant-upload.component';

import { MerchantUploadViewDialog } from './dialogs/merchant-upload-view/merchant-upload-view.component';

import { AccountUploadViewDialog } from './dialogs/account-upload-view/account-upload-view.component';

import { CustomerBulkUploadDialog } from './dialogs/customer-bulk-upload/customer-bulk-upload.component';

import { MeterBulkUpdateDialog } from './dialogs/meter-bulk-update/meter-bulk-update.component';



// Pipe Inventory Components

import { PipeInventoryComponent } from './pipe-inventory/pipe-inventory.component';



// Asset Management Components

import { AssetManagementComponent } from './asset-management/asset-management.component';

import { AssetDialogComponent } from './asset-management/asset-dialog.component';

import { DepreciationDialogComponent } from './asset-management/depreciation-dialog.component';

import { AssetCategoriesComponent } from './asset-management/asset-categories/asset-categories.component';

import { DepreciationReportsComponent } from './asset-management/depreciation-reports/depreciation-reports.component';

// Inventory Management Components

import { InventoryManagementComponent } from './inventory-management/inventory-management.component';

import { PipeInventoryDialogComponent } from './inventory-management/pipe-inventory-dialog.component';

import { StockMovementDialogComponent } from './inventory-management/stock-movement-dialog.component';

import { PurchaseOrderDialogComponent } from './inventory-management/purchase-order-dialog.component';

import { StockMovementsComponent } from './inventory-management/stock-movements/stock-movements.component';

import { PurchaseOrdersComponent } from './inventory-management/purchase-orders/purchase-orders.component';

import { SuppliersComponent } from './inventory-management/suppliers/suppliers.component';

import { InventoryReportsComponent } from './inventory-management/inventory-reports/inventory-reports.component';



// Dialogs Module

import { DialogsModule } from './shared/dialogs/dialogs.module';







@NgModule({



  declarations: [



    AppComponent,



    LoginComponent,



    EmployeeComponent,



    CustomersComponent,



    CustomerDialog,



    EmployeeDialog,



    LoginlayoutComponent,



    MainlayoutComponent,



    ImagepreviewComponent,



    BilldetailsDialog,



    PaymentsComponent,



    MeterdetailsComponent,



    QrcodeComponent,



    AreadetailsComponent,



    UnitrateComponent,



    BillreportsComponent,



    DuebillsComponent,



    CustomerBillsComponent,



    NewbillComponent,



    ExpensesComponent,



    AlertDialog,



    ReceiptpreviewComponent,



    SwitchthemeComponent,



    ComplaintComponent,



    AddcomplaintComponent,



    ViewcomplaintsComponent,



    ControlComponent,



    WagesComponent,



    WagedetailsComponent,



    WageeditComponent,



    WageAuditDialogComponent,



    EmployeeLocationsComponent,



    PayrollRunsComponent,



    PayrollRunDetailsComponent,



    PayrollItemEditDialogComponent,



    PayrollProfilesComponent,



    FuiDashboardComponent,

    ComplaintsDashboardFuiComponent,



    PayslipsComponent,



    MonthlyPayrollExpenseComponent,



    EmployeeProfileFuiComponent,

    EmployeeFormPrintComponent,



    HrAttendanceFuiComponent,



    TranslatePipe,



    HrPayrollGuideComponent,



    BillingDashboardComponent,



    BillingCycleGraphComponent,



    CustomerTransferReportComponent,



    DateChangeComponent,

    DateChangeBillsDialogComponent,

    AuditLogComponent,

MeterChangesComponent,



    

    ViewBillInfoComponent,



    // Asset Management Components

    AssetManagementComponent,

    AssetDialogComponent,

    DepreciationDialogComponent,

    AssetCategoriesComponent,

    DepreciationReportsComponent,



    // Inventory Management Components

    InventoryManagementComponent,

    PipeInventoryDialogComponent,

    StockMovementDialogComponent,

    PurchaseOrderDialogComponent,

    StockMovementsComponent,

    PurchaseOrdersComponent,

    SuppliersComponent,

    InventoryReportsComponent,

    BankComponent,

    AccountUploadDialog,

    CustomerBulkUploadDialog,

    MeterBulkUpdateDialog,

    MerchantUploadDialog,

    MerchantUploadViewDialog,

    AccountUploadViewDialog,



    // Pipe Inventory Components

    PipeInventoryComponent,



  ],



  imports: [



    BrowserModule,



    CommonModule,



    AppRoutingModule,



    FormsModule,



    ReactiveFormsModule,



    HttpClientModule,



    BrowserAnimationsModule,



    MaterialModule,



    QRCodeModule,



    MatDatepickerModule,



    DialogsModule,



    AccessControlModule,



    MatNativeDateModule,



    MatInputModule,



    MatDialogModule,



    MatSlideToggleModule,



    MatPaginatorModule,



    NgSelectModule,



    GoogleMapsModule,



    !environment.production ? StoreDevtoolsModule.instrument() : [],



  ],



  providers: [ApiService, CookieService, PipeInventoryService],



  bootstrap: [AppComponent],



  schemas: [CUSTOM_ELEMENTS_SCHEMA],



})



export class AppModule {}



